/**
 * Events results: count, grid of event cards, empty state. Same section rhythm as M List results.
 */
import React from "react";
import EventCard from "./EventCard";

const EVENTS_PAGE_SIZE = 24;

export default function EventsResultsSection({
  events = [],
  loading,
  searchApplied,
  hasActiveFilters = false,
}) {
  const hasEvents = Array.isArray(events) && events.length > 0;
  const displayed = hasEvents ? events.slice(0, EVENTS_PAGE_SIZE) : [];

  const emptyMessage =
    hasActiveFilters
      ? "No events match your filters. Try changing or clearing them."
      : searchApplied
        ? "No events match your search. Try a different term or clear the filter."
        : "There aren't any upcoming events right now. Check back soon.";

  return (
    <section className="twentytwentysix-content__section twentytwentysix-content__events-results">
      {loading && (
        <p className="twentytwentysix-content__copy">Loading events…</p>
      )}

      {!loading && (
        <>
          <div className="twentytwentysix-content__events-results-header twentytwentysix-content__mlist-results-header">
            <h2 className="twentytwentysix-content__subtitle">
              {hasEvents ? `Upcoming events (${displayed.length})` : "Upcoming events"}
            </h2>
          </div>

          {hasEvents ? (
            <ul className="twentytwentysix-content__list twentytwentysix-content__list--no-bullets twentytwentysix-content__event-grid">
              {displayed.map((ev) => (
                <EventCard key={ev.id} event={ev} />
              ))}
            </ul>
          ) : (
            <div className="twentytwentysix-content__empty-events twentytwentysix-content__empty-listings">
              <p className="twentytwentysix-content__copy">
                {emptyMessage}
              </p>
            </div>
          )}
        </>
      )}
    </section>
  );
}
